<template>
    <div>
        <hc-select ref="elSelectWrap" :value="valueTitle" :clearable="clearable" :size="size" :class="selectClassName" :placeholder="placeholder" :disabled="disabled" @clear="clearHandle" @focus="removeClass">
            <hc-option :value="valueTitle" :label="valueTitle" class="options tree-select-options">
                <hc-tree
                    id="tree-option"
                    ref="selectTree"
                    :data="options"
                    :node-key="props.value"
                    :default-expand-all="true"
                    :default-expanded-keys="[]"
                    @node-click="handleNodeClick"
                >
                    <div slot-scope="{ node, data }" class="custom-tree-node">
                        <span class="content" :class="valueId === data.value ? 'select' : ''">{{ node.label }}</span>
                    </div>
                </hc-tree>
            </hc-option>
        </hc-select>
        <div v-if="showPrompt" class="prompt">
            <!-- <i class="hc-icon-caret-left" /> -->
            <!-- <span class="line" /> -->
            <!-- {{ placeholder }} -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ElTreeSelect',
    props: {
        // 配置项
        props: {
            type: Object,
            default() {
                return {
                    value: 'id', // ID字段名
                    label: 'label', // 显示名称
                    children: 'children', // 子级字段名
                }
            },
        },

        // 选项列表数据(树形结构的对象数组)
        options: { type: Array },

        // 初始值
        value: { type: String, default: null },

        // 输入框大小
        size: { type: String, default: 'small' },

        //占位符
        placeholder: { type: String, default: '请选择环境' },

        // 选择框class
        selectClassName: { type: String, default: '' },

        // 可清空选项
        clearable: { type: Boolean, default: false },

        // 自动收起
        accordion: { type: Boolean, default: false },

        // 显示提示文本
        showPrompt: { type: Boolean, default: false },

        // 是否禁用
        disabled: { type: Boolean, default: false },
        
    },
    data() {
        return {
            valueId: null,
            valueTitle: '',
            defaultExpandedKey: [],
        }
    },

    watch: {
        value() {
            this.valueId = this.value
            this.initHandle()
        },
    },
  
    mounted() {
        this.valueId = this.value
        if (this.options.length > 0) {
            this.initHandle()
            this.defaultExpandedKey = []
        }
    },
    updated() {
        this.initHandle()
        this.defaultExpandedKey = []
    },
    methods: {
        // 初始化值
        initHandle() {
            if (this.valueId) {
                this.$nextTick(() => {
                    this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[this.props.label] // 初始化显示
                    // this.$refs.selectTree.setCurrentKey(this.valueId) // 设置默认选中
                    this.defaultExpandedKey = [] // 设置默认展开
                })
            } else {
                this.valueTitle = ''
                // this.$refs.selectTree.setCurrentKey()
            }
            this.initScroll()
        },
        // 初始化滚动条
        initScroll() {
            this.$nextTick(() => {
                const scrollWraps = document.querySelectorAll('.hc-scrollbar .hc-select-dropdown__wrap')
                scrollWraps.forEach(itemDOM => {
                    itemDOM.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
                    itemDOM.scrollTop = 0
                })
                const scrollBar = document.querySelectorAll('.hc-scrollbar .hc-scrollbar__bar')
                scrollBar.forEach(ele => {
                    ele.style.width = 0
                })
            })
        },

        removeClass() {
            setTimeout(() => {
                const selectLiDoms = document.querySelectorAll('.hc-select-dropdown__item.options.tree-select-options')
                const selectLiDom  = selectLiDoms[0]
                selectLiDom && selectLiDom.classList && selectLiDom.classList.remove('hc-select-dropdown__item')
            }, 1000)
        },

        // 切换选项
        handleNodeClick(node) {
            if (!node.children) {
                this.valueTitle = node[this.props.label]
                this.valueId = node[this.props.value]
                this.$emit('getValue', this.valueId)
                this.$emit('input', this.valueId)
                this.$refs.elSelectWrap.blur()
                this.defaultExpandedKey = []
                if (this.value !== this.valueId) {
                    this.$emit('change', this.valueId)
                }
            }
        },

        // 清除选中
        clearHandle() {
            this.valueTitle = ''
            this.valueId = null
            this.defaultExpandedKey = []
            this.clearSelected()
            this.$emit('getValue', null)
            this.$emit('input', '')
            if (this.value !== '') {
                this.$emit('change', this.valueId)
            }
        },

        // 清空选中样式
        clearSelected() {
            const allNode = document.querySelectorAll('#tree-option .hc-tree-node')
            allNode.forEach(element => element.classList.remove('is-current'))
        },
    },
}
</script>

<style lang="less">
.envType {
  width: 300px;
}
</style>

<style lang="less" scoped>
@deep: ~'>>>';
.hc-tree-node.is-expanded.is-focusable {
  margin-right: 20px;
}
.tree-select-options{
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #3E4352;
  box-sizing: border-box;
  cursor: pointer;
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;

}
.hc-scrollbar .hc-scrollbar__view .hc-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 0px;
}

.hc-select-dropdown__item.selected {
  font-weight: normal;
  color: #3e4352;
}
ul li @{deep} .hc-tree .hc-tree-node__content {
  height: 28px;
  padding: 2px 0px;
}
.hc-tree-node__label {
  font-weight: normal;
}
.hc-tree @{deep} .is-current .hc-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.hc-tree @{deep} .is-current .hc-tree-node__children .hc-tree-node__label {
  color: #606266;
  font-weight: normal;
}

@{deep} .hc-select-dropdown__item span {
  line-height: 14px !important;
}
@{deep} .hc-tree-node__expand-icon {
  color: #3e4352;
  font-size: 14px;
}
@{deep} .hc-tree-node__expand-icon.is-leaf {
  color: transparent;
  cursor: default;
}
.custom-tree-node {
  display: flex;
  flex: 1;
  justify-content: space-between;

  .content{
      padding-right: 10px;
  }
  .select {
      color: #0f77ff;
      font-weight: bold;
  }
  .hc-icon-check {
      font-size: 16px;
      font-weight: 700;
      // position: absolute;
      // right: 15px;
      color: #0f77ff;
      margin-right: 16px;
  }
}
.prompt {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  margin-left: 11px;
  color: rgba(62, 67, 82, 0.4);
  .line {
      width: 123px;
      display: inline-block;
      margin: 0 8px 0 -5px;
      border-bottom: 1px dashed #D3D8E9;
  }
  .hc-icon-caret-left {
      font-size: 16px;
      color: #D3D8E9;
  }
}
</style>
